import { z } from 'zod';
import { CYCLE_TYPES, ROLES } from '../enums';
import { emailSchema, idSchema, latitudeSchema, longitudeSchema, passwordSchema, phoneSchema, } from './common';
// =============================================================================
// Utilisateurs
// =============================================================================
export const createUserSchema = z.object({
    email: emailSchema,
    password: passwordSchema,
    firstName: z.string().trim().min(2).max(100),
    lastName: z.string().trim().min(2).max(100),
    phone: phoneSchema.optional().nullable(),
    role: z.enum(ROLES),
    isActive: z.boolean().default(true),
});
export const updateUserSchema = createUserSchema.partial().omit({ password: true });
/** Un client peut modifier sa fiche, mais ni son role ni son statut d'activation. */
export const updateProfileSchema = z.object({
    firstName: z.string().trim().min(2).max(100).optional(),
    lastName: z.string().trim().min(2).max(100).optional(),
    phone: phoneSchema.nullable().optional(),
});
// =============================================================================
// Adresses
// =============================================================================
export const addressSchema = z.object({
    id: idSchema,
    label: z.string().nullable(),
    street: z.string(),
    city: z.string(),
    postalCode: z.string(),
    country: z.string(),
    lat: z.number(),
    lng: z.number(),
    isDefault: z.boolean(),
});
export const createAddressSchema = z.object({
    /** Libelle libre choisi par le client : « Domicile », « Bureau »... */
    label: z.string().trim().max(60).optional().nullable(),
    street: z.string().trim().min(3, 'Rue requise.').max(255),
    city: z.string().trim().min(1, 'Ville requise.').max(100),
    postalCode: z
        .string()
        .trim()
        .regex(/^\d{5}$/, 'Code postal francais invalide (5 chiffres).'),
    country: z.string().trim().max(60).default('France'),
    /**
     * Coordonnees issues du geocodage BAN. Elles sont obligatoires : sans elles,
     * impossible de resoudre la zone d'intervention (RG-02).
     */
    lat: latitudeSchema,
    lng: longitudeSchema,
    isDefault: z.boolean().default(false),
});
export const updateAddressSchema = createAddressSchema.partial();
// --- Geocodage (Base Adresse Nationale) --------------------------------------
export const geocodeQuerySchema = z.object({
    q: z.string().trim().min(3, 'Saisissez au moins 3 caracteres.').max(200),
    limit: z.coerce.number().int().min(1).max(10).default(5),
});
export const geocodeSuggestionSchema = z.object({
    /** Adresse complete formatee, prete a etre affichee. */
    label: z.string(),
    street: z.string(),
    city: z.string(),
    postalCode: z.string(),
    country: z.string(),
    lat: z.number(),
    lng: z.number(),
    /** Score de pertinence renvoye par la BAN, entre 0 et 1. */
    score: z.number(),
});
// =============================================================================
// Cycles
// =============================================================================
const currentYear = new Date().getFullYear();
export const createBicycleSchema = z.object({
    brand: z.string().trim().min(1, 'Marque requise.').max(100),
    /** Exige par l'enonce : « des informations concernant le modele, l'annee et le type ». */
    model: z.string().trim().min(1, 'Modele requis.').max(100),
    manufacturedYear: z
        .number()
        .int()
        .min(1950, 'Annee trop ancienne.')
        .max(currentYear + 1, 'Annee dans le futur.'),
    type: z.enum(CYCLE_TYPES, {
        errorMap: () => ({ message: 'Type de cycle invalide.' }),
    }),
    serialNumber: z.string().trim().max(100).optional().nullable(),
    notes: z.string().trim().max(1000).optional().nullable(),
});
export const updateBicycleSchema = createBicycleSchema.partial();
export const bicycleSchema = createBicycleSchema.extend({
    id: idSchema,
    ownerId: idSchema,
    createdAt: z.string(),
});
//# sourceMappingURL=users.js.map